import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const postConsentTrial = async ({ title, content, title_de, content_de, title_es, content_es }) => {
  const token = localStorage.getItem("token");

  const payload = {
    title,
    content,
    title_de: title_de || "",
    content_de: content_de || "",
    title_es: title_es || "",
    content_es: content_es || "",
  };

  const { data } = await axios.post(`${__API_URL__}/api/appiell/consent_trial/`, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return data;
};

const useConsentTrialMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postConsentTrial,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["consent_trial"] });
    },
  });
};

export default useConsentTrialMutation;
